// ante-react-kit/src/pos/AntCashDropPopup/index.js
import React, { useState } from 'react';
import { NumberBox, TextArea, TextBox, SelectBox } from 'devextreme-react';
import AntPasscodeOverlay from '../../components/AntPasscodeOverlay';
import AntAuth from '../../utils/AntAuth';

export default function AntCashDropPopup(props) {
    const { session, onDone, onClose } = props;
    const [amount, setAmount] = useState(0);
    const [reason, setReason] = useState('');
    const [targetAccount, setTargetAccount] = useState(null);
    const [recipient, setRecipient] = useState('');
    const [errorText, setErrorText] = useState('');
    const [errorKey, setErrorKey] = useState(0);
    const [processing, setProcessing] = useState(false);

    const reportError = (msg) => { setErrorText(msg); setErrorKey((k) => k + 1); };

    const useCA = AntAuth.getBusSetting('use_Module_CA') === 1;

    const handleComplete = (passCode) => {
        if (!amount || amount <= 0) { reportError('Nhập số tiền'); return; }
        if (!reason) { reportError('Nhập lý do'); return; }
        setProcessing(true);
        AntAuth.callApi('user/ACUserAuthen/cashShift/drop', {
            amount, reason, target_cash_account_code: targetAccount, recipient_user_code: recipient, pass_code: passCode
        }, (res) => {
            setProcessing(false);
            if (res && res.error) { reportError((res.error.message && res.error.message.vi) || 'Lỗi'); return; }
            if (onDone) onDone(res && res.data);
        });
    };

    const topSlot = (
        <div className="apt-shift-top">
            <div className="apt-shift-row">
                <span className="apt-shift-label">Số tiền</span>
                <NumberBox value={amount} onValueChanged={(e) => setAmount(e.value)} format="#,##0" width={180} />
            </div>
            <div className="apt-shift-row">
                <span className="apt-shift-label">Lý do</span>
                <TextArea value={reason} onValueChanged={(e) => setReason(e.value)} height={60} width={260} />
            </div>
            {useCA && (
                <div className="apt-shift-row">
                    <span className="apt-shift-label">Két nhận</span>
                    <SelectBox
                        value={targetAccount} onValueChanged={(e) => setTargetAccount(e.value)}
                        dataSource={[]} width={180} placeholder="Chọn két..."
                    />
                </div>
            )}
            <div className="apt-shift-row">
                <span className="apt-shift-label">Người nhận</span>
                <TextBox value={recipient} onValueChanged={(e) => setRecipient(e.value)} width={180} />
            </div>
        </div>
    );

    return (
        <AntPasscodeOverlay
            title="Rút quỹ"
            subtitle="Bàn giao tiền mặt khỏi két"
            topSlot={topSlot}
            bottomActions={<button type="button" className="apt-passcode-secondary-btn" onClick={onClose}>Huỷ</button>}
            processing={processing}
            errorText={errorText}
            errorKey={errorKey}
            onComplete={handleComplete}
            dismissible={true}
            onDismiss={onClose}
        />
    );
}
